import React, { Component } from 'react';
import { Drawer, Button } from 'antd';
import './Filters.css';
import { inject, observer } from 'mobx-react';
import { isFunction } from 'lodash';
import MaintenanceTypeFilter from './filters/MaintenanceTypeFilter';
import AlimentationFilter from './filters/AlimentationFilter';
import NextMaintenanceFilter from './filters/NextMaintenanceFilter';
import SubscriptionEndFilter from './filters/SubscriptionEndFilter';
import RegistrationYearFilter from './filters/RegistrationYearFilter';
import KmAvgFilter from './filters/KmAvgFilter';
import MileageFilter from './filters/MileageFilter';

import MakeModelFilter from './filters/MakeModelFilter';
import DealerFilter from './filters/DealerFilter';

@inject('translationsStore', 'filterStore', 'carsStore', 'authStore')
@observer
export default class Filters extends Component {
  constructor(props) {
    super(props);
    this.AlimentationFilterRef = React.createRef();
    this.KmAvgFilterRef = React.createRef();
    this.MileageFilterRef = React.createRef();
    this.MaintenanceTypeFilterRef = React.createRef();
    this.DealerFilterRef = React.createRef();
    this.MakeModelFilterRef = React.createRef();
    this.NextMaintenanceFilterRef = React.createRef();
    this.SubscriptionEndFilterRef = React.createRef();
    this.RegistrationYearFilterRef = React.createRef();

    this.state = {
      visible: false
    };
  }

  componentDidMount() {
    if (this.props.cars) {
      this.init(this.props.cars);
    }

  }

  componentDidUpdate(prevProps) {
    if (this.props.cars && this.props.cars !== prevProps.cars) {
      this.init(this.props.cars);
    }
  }

  show() {
    this.setState({ visible: true });
  }

  hide() {
    this.setState({ visible: false });
  }

  toggle() {
    this.setState({ visible: !this.state.visible });
  }

  resetFilters() {
    let newState = {};
    Object.keys(this.state)
      .filter(k => this.state.hasOwnProperty(k))
      .filter(k => k.startsWith('selected'))
      .forEach(k => (newState[k] = null));
    this.setState(Object.assign({}, this.state, newState, { models: [] }));
    this.reset();
  }

  init(cars) {
    this.setState({ cars }, () => {});
  }

  apply = () => {
    const { filterStore } = this.props;
    if (this.props.apply && isFunction(this.props.apply)) {
      this.props.apply();
    }
    if (this.props.apply !== false) {
      filterStore.apply();
      Object.keys(filterStore.appliedFilters).filter(appliedFilter => appliedFilter.startsWith('carFilter_'));
      //this.hide();
    }
  };

  reset = () => {
    this.props.filterStore.reset();
  };

  render() {
    const { visible } = this.state;
    const { translationsStore, filterStore, authStore } = this.props;
    return (
      <div className="Filters" id="Filters">
        <Drawer
          className="FiltersDrawer"
          visible={visible}
          onClose={this.hide.bind(this)}
          placement="right"
          width="550px"
          title={translationsStore.translate('carList.filters.title')}
        >
          <KmAvgFilter ref={this.KmAvgFilterRef} status={filterStore.contains('carFilter_avgKm')}/>
          <MileageFilter ref={this.MileageFilterRef} status={filterStore.contains('carFilter_mileage')}/>
          <MakeModelFilter ref={this.MakeModelFilterRef} status={filterStore.contains('carFilter_makesModels')}/>
          <RegistrationYearFilter ref={this.RegistrationYearFilterRef} status={filterStore.contains('carFilter_minRegYear') || filterStore.contains('carFilter_maxRegYear')}/>
          <AlimentationFilter ref={this.AlimentationFilterRef} status={filterStore.contains('carFilter_alimentation')}  />
          <NextMaintenanceFilter ref={this.NextMaintenanceFilterRef} status={filterStore.contains('carFilter_startMonthToM') || filterStore.contains('carFilter_endMonthToM')}/>
          <SubscriptionEndFilter ref={this.SubscriptionEndFilterRef} status={filterStore.contains('carFilter_subscriptionStart') || filterStore.contains('carFilter_subscriptionEnd')} />
          <MaintenanceTypeFilter ref={this.MaintenanceTypeFilterRef} status={filterStore.contains('carFilter_maintenance')}/>
          {authStore.isAdmin && <DealerFilter ref={this.DealerFilterRef} status={filterStore.contains('carFilter_dealer')} />}

          <div>
            <div className="buttons">
              <Button onClick={this.reset}>{translationsStore.translate('common.button.reset')}</Button>
              <Button className={filterStore.changes === false ? 'apply disabled' : 'apply'} disabled={filterStore.changes === false} onClick={this.apply}>
                {translationsStore.translate('common.button.apply')}
              </Button>
            </div>
          </div>
        </Drawer>
      </div>
    );
  }
}
